<template>
  <div>
    <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top is-border-bottom">
      <div class="is-border-right is-border-left  columns is-marginless">
        <div
          class="column is-narrow is-flex is-padding-small">
          <span
            class="icon is-self-centered">
            <i class="fal fa-3x fa-file-alt"></i>
          </span>
        </div>
        <div
          class="column is-self-centered is-padding-small width-125">
          <div class="title is-5">
            {{ sectionName }}
          </div>
        </div>
      </div>
      <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
        <div class="column">
          <span v-if="!editionMode">
            <a
              class="is-size-6 is-uppercase">{{ newName }}</a>&nbsp;
            <a
              @click="editionMode = true"><span class="icon"><i class="fal fa-pencil"></i></span></a>
            <a
              @click="editionMode = true"><span class="is-underline"> Modifier</span></a>
          </span>
          <input
            v-else-if="editionMode"
            type="text"
            @click="$event.target.select()"
            v-model="newName"
            @input="updateName(newName)"
            class="input is-uppercase is-borderless is-small is-fullwidth is-shadowless"
            placeholder="Entrer le titre de la section">
          <span
            v-else
            class="is-size-6">{{ newName }}</span>
        </div>
      </div>
      <div
        v-if="hidePage"
        class="is-self-centered is-gapless is-vcentered is-margin-right-small">
        <input
          :id="'hide_page_' + sectionName"
          v-model="hidePageData"
          :name="'hide_page_' + sectionName"
          class="switch is-success is-rounded"
          @change="$emit('hidePage', hidePageData)"
          type="checkbox">
        <label
          :for="'hide_page_' + sectionName"
          style="font-size: 12.5px"
          class="is-uppercase">Masquer cette page</label>
      </div>
      <div
        @click="showContent = !showContent"
        class="column is-narrow has-background-white is-border-right is-border-left is-flex is-padding">
        <span class="icon is-self-centered"><i
          :class="showContent ? 'fal fa-times' : 'fal fa-chevron-down'"></i></span>
      </div>
    </div>
    <template v-if="showContent">
      <template v-if="hasMentions">
        <template v-if="mentions.length > 0">
          <mention-section-bloc
            v-for="(mention, index) in mentions"
            :key="index"
            :index="index"
            :is-before="mention.is_before"
            :content="mention.content"
            :mentions-activated="mentionsActivated"
            @updateRadio="updateRadio"
            @updateComment="updateComment"
            @deleteMention="val => $emit('deleteMention', val)">
          </mention-section-bloc>
        </template>
        <div
          class="">
          <button
            @click="$emit('addMention')"
            class="button is-fullwidth is-radiusless is-minH50p is-uppercase"
            style="background-color: #5C5C5C; border-color: #5C5C5C; color: #fff">
            <span>Ajouter mention</span>
          </button>
        </div>
      </template>
      <div
        v-if="hideMandataries"
        class="columns is-12 is-gapless is-marginless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
        :class="!boolHideMandataries ? 'is-border-top has-background-light is-border-left is-border-right is-border-bottom ' : 'has-background-dark'">
        <div class="column is-narrow">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
            <div>
              <input
                id="hide_mandataries"
                v-model="boolHideMandataries"
                name="hide_mandataries"
                class="switch is-success is-rounded"
                @change="updateMandataries"
                type="checkbox">
              <label
                for="hide_mandataries"
                style="font-size: 12.5px"
                :class="!boolHideMandataries ? '' : 'has-text-white'"
                class="is-uppercase">Masquer les coordonnées du mandataire</label>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="feesSection"
        class="columns is-12 is-gapless is-marginless is-padding-left-small is-padding-right-small is-vcentered is-minH50p has-background-white is-border-left is-border-right is-border-bottom">
        <div class="column is-narrow">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
            <div>
              <div
                style="font-size: 12.5px"
                class="is-uppercase">
                Mention «Frais et commission»
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="feesSection"
        class="">
        <custom-mention-section-bloc
          :key="'mention_fees'"
          :content="contentFees"
          before-wysiwyg-text="Dans le cadre d'une vente sans commission plafonnée."
          @updateComment="val => patchCustomContent('content', val)">
        </custom-mention-section-bloc>
        <!-- <custom-mention-section-bloc
          :key="'mention_fees_pinel'"
          :content="contentFeesPinel"
          before-wysiwyg-text="Dans le cadre d'une vente avec commission plafonnée (Pinel)."
          @updateComment="val => patchCustomContent('pinel_content', val)">
        </custom-mention-section-bloc> -->
      </div>
      <div
        v-if="notificationSection"
        class="">
        <custom-mention-section-bloc
          :key="'authorized_notification'"
          :content="contentAuthorizedNotification"
          @updateComment="val => patchCustomContent('authorized_notification', val)">
        </custom-mention-section-bloc>
        <custom-mention-section-bloc
          :key="'buyer_recognition'"
          :content="contentBuyerRecognition"
          @updateComment="val => patchCustomContent('buyer_recognition', val)">
        </custom-mention-section-bloc>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  name: 'ContractSectionBloc',
  components: {
    MentionSectionBloc: () => import('./MentionSectionBloc'),
    CustomMentionSectionBloc: () => import('./CustomMentionSectionBloc')
  },
  props: {
    sectionName: {
      type: String
    },
    name: {
      type: String
    },
    mentions: {
      type: Array
    },
    hasMentions: {
      type: Boolean,
      default: true
    },
    hidePage: {
      type: Boolean,
      default: false
    },
    hidePageDataProps: {
      type: Boolean,
      default: false
    },
    hideMandataries: {
      type: Boolean,
      default: false
    },
    hideMandatariesData: {
      type: Boolean,
      default: false
    },
    feesSection: {
      type: Boolean,
      default: false
    },
    feesSectionContent: {
      type: Object,
      default: null
    },
    notificationSection: {
      type: Boolean,
      default: false
    },
    notificationSectionContent: {
      type: Object,
      default: null
    },
    mentionsActivated: {
      type: Boolean,
      default: true
    },
    inputSectionAdfCustom: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hidePageData: null,
      showContent: false,
      contentFees: null,
      // contentFeesPinel: null,
      contentAuthorizedNotification: null,
      contentBuyerRecognition: null,
      editionMode: false,
      open: false,
      newName: null,
      boolHideMandataries: false
    }
  },
  watch: {
  },
  created () {
    if (this.hidePage) {
      this.hidePageData = this.hidePageDataProps
    }
    if (this.hideMandataries) {
      this.boolHideMandataries = this.hideMandatariesData
    }
    this.newName = this.name
    if (this.feesSection) {
      this.contentFees = this.feesSectionContent.content
      // this.contentFeesPinel = this.feesSectionContent.pinel_content
    }
    if (this.notificationSection) {
      this.contentAuthorizedNotification = this.notificationSectionContent.authorized_notification
      this.contentBuyerRecognition = this.notificationSectionContent.buyer_recognition
    }
  },
  methods: {
    updateMandataries () {
      this.$emit('updateMandataries', this.boolHideMandataries)
    },
    updateComment (idx, val) {
      this.$emit('updateComment', [idx, val])
    },
    updateRadio (idx, val) {
      this.$emit('updateRadio', [idx, val])
    },
    updateName (value) {
      this.$emit('updateName', value)
    },
    openWysiwyg () {
      this.openCommentWysiFees = true
    },
    // openWysiwygPinel () {
    //   this.openCommentWysiFeesPinel = true
    // },
    async patchCustomContent (destination, value) {
      this.$emit('updateCustomContent', [destination, value])
    }
  }
}
</script>

<style scoped>
    .width-125 {
      width: 125px;
    }
</style>
